import React, { useState, useEffect, useContext } from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import { observer } from 'mobx-react'

import SDOContext from '../sdo.js'
import ddo from '../ddo.js'

import Wsc_Top from './com/wsc_top.js';
import Wsc_Mnu from './com/wsc_mnu.js';
import Wsc_Foot from './com/wsc_foot.js';

import Wsc_Home from './home.js';
import Wsc_Dash from './dash.js';
import Wsc_Msa from './msa.js';
import Wsc_Bo from './bo.js';

import * as net from "../lib/net";
import Tiden from "../lib/ui/tiden";
import {withRouter} from "../lib/react/withRouter";
import sso from "../sso";

function web01() {

    var html =
    <div className="web-content">
    </div>
    ;
    return html;
}

class Wsc extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.pos = props.store.pos;
    this.state = { pgid: 11, mnu_show: true, deps: [] };
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    //this.props.fetchWells()
    //  .then(res => this.setState({ wells: res.wells }) )
    var deps = [];
    deps.push( {"id": "01", "text": "DEP X1" } );
    deps.push( {"id": "02", "text": "DEP X2" } );
    deps.push( {"id": "03", "text": "DEP X3" } );

    //this.props.store.seo.cs = "5";
    ///this.props.store.seo.unit = "BSENHET";

    var pos = {};
    pos.deps = deps;
    pos.vgrps = [];
    pos.plus = [];
    this.props.store.pos = pos;
    //alert(JSON.stringify(pos));
    //this.wsc_init();
  }
    tmpl_init() {
        var self = this;

        ddo.cache.avd = sso.seo.avd;
        ddo.cache.auth = sso.seo.auth;
        //alert(JSON.stringify(ddo.cache));

        ddo.cache.depo = {};
        ddo.cache.deps = [];
        ddo.cache.vgrps = [];
        ddo.cache.vga = [];
        ddo.cache.mkods = {};

        var req = {};
        req.req = "pos.pos_fkn.pos_init";

        net.sio_req(req)
            .then(function(ret){
                //alert(JSON.stringify(ret));

                if(!self.props.store.pos) self.props.store.pos = {};
                self.props.store.pos.deps = ret.rco.deps;
                self.props.store.pos.vgrps = ret.rco.vgrps;
                if(ret.rco.depo) ddo.cache.depo = ret.rco.depo;
                if(ret.rco.deps) ddo.cache.deps = ret.rco.deps;
                if(ret.rco.vgrps) ddo.cache.vgrps = ret.rco.vgrps;
                if(ret.rco.mkods) ddo.cache.mkods = ret.rco.mkods;

                var avd = Object.keys(ddo.cache.deps).sort()[0];
                if((avd * 1) > (ddo.cache.avd * 1)) {
                    ddo.cache.avd = avd;
                }
                ddo.cache.avdtxt = "";
                if(ddo.cache.depo[ddo.cache.avd]) {
                    var dpo = ddo.cache.depo[ddo.cache.avd];
                    //alert(JSON.stringify(dpo));
                    ddo.cache.avdtxt = dpo.text;
                }
                var a = [];
                a.push({ var00: { v0katnr: '000', v0text: 'ALLA VGRP' } });
                if(ddo.cache.vgrps) a = a.concat(ddo.cache.vgrps);
                ddo.cache.vga = a;
                //alert(JSON.stringify(ddo.cache.vgrps));
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
                //alert(JSON.stringify(txt));
            })
        //ddo.cache.auth = "09";
    }

  fknGo(url) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    //var fkn = row.fid;
    //setState({ row : row,  ma : [] });
    //ctx.fid = fkn;

    //props.history.push(row.url);
    this.props.navigate(url);
   };

  ddo() {
    //alert("POS" + this.state.pgid );
    //this.setState({ status: 1 });
  }

    tech_init() {
    var self = this;

    ddo.cache.deps = {};
    ddo.cache.vgrps = [];
    ddo.cache.mkods = {};

	var req = {};
	req.req = "pos.pos_fkn.pos_init";

    net.sio_req(req)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(!self.props.store.pos) self.props.store.pos = {};
        self.props.store.pos.deps = ret.rco.deps;
        self.props.store.pos.vgrps = ret.rco.vgrps;
        if(ret.rco.depo) ddo.cache.deps = ret.rco.depo;
        if(ret.rco.vgrps) ddo.cache.vgrps = ret.rco.vgrps;
        if(ret.rco.mkods) ddo.cache.mkods = ret.rco.mkods;

        var avd = Object.keys(ddo.cache.deps).sort()[0];
        if((avd * 1) > (ddo.cache.avd * 1)) {
            ddo.cache.avd = avd;
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //alert(JSON.stringify(txt));
    })
    }

  render() {

    return (
    <div className="web-app">
    <div className="web-top">
        <Wsc_Top store={this.store} />
    </div>
    <div className="web-main">

    <div className="web-row" style={{ height:"100%" }}>

    { this.props.store.cfg.mnu_show ?
    <div className="web-side">
        <Wsc_Mnu store={this.store} />

    </div>
    : null }

    <div className="web-body">
          <Routes>
              <Route path="msa/*" element={ <Wsc_Msa store={this.store} />} />
              <Route path="bo/*" element={ <Wsc_Bo store={this.store} />} />
              <Route path="home" element={ <Wsc_Home store={this.store} />} />
              <Route path="*" element={ <Wsc_Dash store={this.store} />} />
          </Routes>
    </div>

    </div>

    </div>

        <Wsc_Foot store={this.store} />

    </div>
  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(observer(Wsc));
